import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import {
   Button, ButtonToolbar, Modal, Table, UncontrolledTooltip, FormGroup, Col, Row,
} from 'reactstrap';
import { reduxForm } from 'redux-form';
import Moment from 'moment';
import ReactPaginate from 'react-paginate';

import CalendarIcon from 'mdi-react/CalendarIcon';
import DatePicker from 'react-datepicker';
import CommonService from '../../services/CommonService';
import ProductListsModal from './ProductListsModal';
import global from '../../global';

class TransactionListModal extends PureComponent {
   static propTypes = {
      modal: PropTypes.bool,
      title: PropTypes.string,
      toggle: PropTypes.func.isRequired,
      id: PropTypes.oneOfType([
         PropTypes.string,
         PropTypes.number,
      ]).isRequired,
   };

   static defaultProps = {
      modal: false,
      title: '',
   };

   constructor() {
      super();
      this.perPage = 7;
      this.state = {
            mmodal: false,
            realList: [],
            list: [],
            salesid: '',
            formdata: {},
      };
      this.userid = 0;
      this.toggleModal = this.toggleModal.bind(this);
      this.handleClick = this.handleClick.bind(this);
      this.searchTransaction = this.searchTransaction.bind(this);
   }

   componentDidMount() {
      const { id } = this.props;
      this.isLoading = true;
      this.userid = id;
      this.onLoadTransactions(id);
   }

   componentWillReceiveProps(nextProps) {
      this.isLoading = true;
      this.userid = nextProps.id;
      this.onLoadTransactions(nextProps.id);
   }

   componentWillUnmount() {
      this.isLoading = false;
   }

   onLoadTransactions = async (id, fromdate = '', todate = '') => {
      const urlId = `/customerid/${id}`;
      const urlFdate = fromdate !== '' ? `/fromdate/${fromdate}` : '';
      const urlTdate = todate !== '' ? `/to/${todate}` : '';
      try {
            const response = await CommonService.getRows(`sales${urlId}${urlFdate}${urlTdate}`);
            if (response) {
                this.setState({ list: response, realList: response });
                this.handleClick();
            }
      } catch (err) {
         console.log('Error: ', err.message);
      }
      this.isLoading = false;
   }

   handleChange = (e, fieldName) => {
      if (fieldName === 'fromDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           fromDate: date,
         },
       }));
     } else if (fieldName === 'toDate') {
       const date = new Date(e);
       this.setState(prevState => ({
         formdata: {
           ...prevState.formdata,
           toDate: date,
         },
       }));
     } else {
       const { name, value } = e.target;
       this.setState(prevState => ({
         formdata: { ...prevState.formdata, [name]: value },
       }));
     }
   }

   handleClick(event = '') {
      const selected = event !== '' ? event.selected + 1 : 1;
      const { realList } = this.state;

      const lastPost = selected * this.perPage;
      const firstPost = lastPost - this.perPage;

      const newList = realList.slice(firstPost, lastPost);
      this.setState({ list: newList });
   }

    viewproducts(e, paramdata) {
        e.preventDefault();
        const {
            salesid, total, amountPaid, balance, drnumber,
        } = paramdata;

        this.executeModal = 'viewproducts';
        this.toggleModal();
        this.setState({
            salesid, total, amountPaid, balance, drnumber,
        });
    }

    toggleModal() {
        this.setState(prevState => ({ mmodal: !prevState.mmodal }));
    }

    searchTransaction(e) {
       e.preventDefault();
       const { formdata } = this.state;
       const fromDate = Moment(formdata.fromDate).format('YYYY-MM-DD');
       const toDate = Moment(formdata.toDate).format('YYYY-MM-DD');
       this.onLoadTransactions(this.userid, fromDate, toDate);
    }

   render() {
        const {
            modal, toggle, title,
        } = this.props;

        const {
          list, mmodal, salesid, total, amountPaid, balance, drnumber, realList, formdata,
        } = this.state;

      // from date
      let fromDate = new Date();
      if (formdata.fromDate) {
        fromDate = new Date(formdata.fromDate);
      }
      // to date
      let toDate = new Date();
      if (formdata.toDate) {
        toDate = new Date(formdata.toDate);
      }

      return (
         <div>
         {
           this.executeModal === 'viewproducts' ? (
             <ProductListsModal
               salesId={salesid}
               toggle={this.toggleModal}
               modal={mmodal}
               total={total}
               amountPaid={amountPaid}
               balance={balance}
               drnumber={drnumber}
             />
           ) : ''
         }
            <Modal
               isOpen={modal}
               className="modal-dialog--primary modal-dialog--header modal-lg"
            >
               <div className="modal__header bg_blue">
                  <button className="lnr lnr-cross modal__close-btn" type="button" onClick={toggle} />
                  <h4 className="bold-text  modal__title">{title !== '' ? title : 'Payment Lists'}</h4>
               </div>
               <div className="modal__body p-t-10">
                  <Row className="m-0">
                     <Col md={12} className="m-b-20">
                        <form className="form form--horizontal the_form_display" onSubmit={this.searchTransaction}>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Date From:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="fromDate"
                                    selected={fromDate}
                                    popperPlacement="top"
                                    onChange={e => this.handleChange(e, 'fromDate')}
                                 />
                              </div>
                           </div>
                           <div className="form__form-group m-b-7">
                              <div className="form__form-group-field m-l-0">
                                 <span className="form__form-group-label text-right m-r-10 mw-65 xw-65">Date To:</span>
                                 <div className="form__form-group-icon">
                                    <CalendarIcon />
                                 </div>
                                 <DatePicker
                                    name="toDate"
                                    selected={toDate}
                                    popperPlacement="top-end"
                                    onChange={e => this.handleChange(e, 'toDate')}
                                 />
                                 <button type="submit" className="form__form-group-button bg-primary">Search</button>
                              </div>
                           </div>
                        </form>
                     </Col>
                  </Row>
                  <Table className="no_hover" id="payments_table" responsive>
                     <thead>
                        <tr>
                            <th>Reference No.</th>
                            <th>Total Sales</th>
                            <th>Amount Paid</th>
                            <th>Balance</th>
                            <th>Date</th>
                            <th>Action</th>
                        </tr>
                     </thead>
                     <tbody>
                     {
                        list !== false || list.length > 0 ? list.map((item, key) => {
                            const refNum = item.dr_number;
                            const totalSale = item.total !== '' ? global.parseToNumber(item.total, 'float') : 0;
                            const paidAmount = item.amount_paid !== '' ? global.parseToNumber(item.amount_paid, 'float') : 0;
                            const currentBalance = item.balance !== '' ? global.parseToNumber(item.balance, 'float') : 0;
                            const param = {
                              salesid: item.sales_id,
                              total: item.total,
                              amountPaid: item.amount_paid,
                              balance: item.balance,
                              drnumber: item.dr_number,
                            };

                            return (
                                <tr key={`paymentList${key + 1}`}>
                                    <td>{refNum}</td>
                                    <td><span className="m-r-2">&#x20B1;</span> {global.numberFormat(totalSale)}</td>
                                    <td><span className="m-r-2">&#x20B1;</span> {global.numberFormat(paidAmount)}</td>
                                    <td><span className="m-r-2">&#x20B1;</span> {global.numberFormat(currentBalance)}</td>
                                    <td>{item.date_sales !== '' ? item.date_sales : '---'}</td>
                                    <td>
                                        <Button color="primary" className="btn-xs" onClick={e => this.viewproducts(e, param)} id={`viewprodbtn${key + 1}`} outline><span className="fa fa-eye" /></Button>
                                        <UncontrolledTooltip target={`viewprodbtn${key + 1}`}>View Products</UncontrolledTooltip>
                                    </td>
                                </tr>
                            );
                        }) : (
                           <tr className="text-center">
                              <td colSpan="6"><i>No payments available..</i></td>
                           </tr>
                        )
                     }
                     </tbody>
                  </Table>
                     <FormGroup className={list === false || (realList.length / this.perPage) <= 1 ? 'display-none' : ''}>
                        <ReactPaginate
                           previousLabel="<<"
                           nextLabel=">>"
                           breakLabel="..."
                           breakClassName="break-me"
                           pageCount={realList.length / this.perPage}
                           onPageChange={this.handleClick}
                           marginPagesDisplayed={0}
                           pageRangeDisplayed={2}
                           containerClassName="list-pagination"
                           activeClassName="active"
                        />
                     </FormGroup>
               </div>
               <ButtonToolbar className="modal__footer">
                  <Button onClick={toggle}>Close</Button>
               </ButtonToolbar>
            </Modal>
         </div>
      );
   }
}

export default reduxForm({
  form: 'TransactionListModal', // a unique identifier for this form
})(TransactionListModal);
